export enum RightMenuNavigation {
  Home = 'home',
  Notification = 'notification',
  Messages = 'messages',
  GlobalChat = 'global-chat',
  Players = 'players',
}
